<template>
    <div>
        <h3>Listado de cookies</h3>
        <h4 style="border-bottom: dashed 1px #cacaca; margin-bottom: 1.5rem; padding-bottom: 10px">Cookies esenciales</h4>
        <div class="table_wrapper">
            <table class="table" style="margin-bottom: 1.5rem;">
                <thead>
                    <tr>
                        <th class="tg-0pky">Nombre</th>
                        <th class="tg-0pky">Descripción</th>
                        <th class="tg-0pky">Proveedor</th>
                        <th class="tg-0pky">Duración</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(c, index) in necessaryCookies" :key="index">
                        <td class="tg-0pky">{{ c.name }}</td>
                        <td class="tg-0pky">{{ c.description }}</td>
                        <td class="tg-0pky">{{ c.provider }}</td>
                        <td class="tg-0pky">{{ c.duration }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <h4 class="mb20" style="border-bottom: dashed 1px #cacaca; margin-bottom: 1.5rem; padding-bottom: 10px">Cookies opcionales</h4>
        <div v-for="(g, index) in optionalCookieGroups" :key="index"  class="mb-4">
            <h5 style="margin-bottom: 1rem;">{{ g.name }}</h5>
            <div class="table_wrapper">
                <table class="table" style="margin-bottom: 2rem;">
                    <thead>
                        <tr>
                            <th class="tg-0pky">Nombre</th>
                            <th class="tg-0pky">Descripción</th>
                            <th class="tg-0pky">Proveedor</th>
                            <th class="tg-0pky">Duración</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ck, index) in g.cookies" :key="index">
                            <td class="tg-0pky">{{ ck.name }}</td>
                            <td class="tg-0pky">{{ ck.description }}</td>
                            <td class="tg-0pky">{{ ck.provider }}</td>
                            <td class="tg-0pky">{{ ck.duration }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="btn small graphic_right grey" @click="openModal">Modificar las opciones de cookies</div>
    </div>
</template>
<script>
import { necessaryCookies, optionalCookieGroups } from '@/includes/cookies';
import emitter from '@/includes/eventBus';

export default {
    components:{},
    props:{},
    data: function(){
        return{
            necessaryCookies: necessaryCookies,
            optionalCookieGroups: optionalCookieGroups,
        }
    },
    methods: {
        openModal: () => emitter.emit('open_modal_cookies', 2)
    }
}
</script>
<style scoped>
.table_wrapper {
    overflow-x: auto;
}
.table {
    border-color: #e1e1e1;
    border-style: solid;
    border-width: 1px 1px 0 1px;
    background-color: #fff;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
}
.table tr {
    border-bottom: solid 1px #e1e1e1;
}
.table tr.odds {
    background-color: #eaeaea;
}
.table th {
    background-color: #f4f4f4;
    color: #333;
    font-size: 0.75rem;
    word-break: normal;
}
.table th,
.table td {
    border-left: solid 1px #e1e1e1;
    padding: 8px 10px;
}
.table th:first-child,
.table td:first-child {
    border-left: none;
}
.table th a,
.table td a {
    color: #000;
}
.table td a:hover {
    text-decoration: underline;
}
.table td {
    border-left: solid 1px #e1e1e1;
    border-bottom: solid 1px #e1e1e1;
    color: #000;
    font-size: 0.75rem;
    word-break: normal;
    vertical-align: middle;
}
.table td:first-child {
    text-align: left;
}
.table td:last-child {
    text-align: center;
}
.table td svg {
    height: 14px;
    width: 14px;
}
.table p {
    margin-bottom: 0;
    font-size: 12px;
}
.table button.graphic,
.table .button.graphic {
    background: none;
    cursor: pointer;
}
.table button.graphic svg,
.table .button.graphic svg {
    fill: #858585;
}
.table button.graphic.ok:hover svg,
.table .button.graphic.ok:hover svg {
    fill: #3ad20b;
}
.table button.graphic.ko:hover svg,
.table .button.graphic.ko:hover svg {
    fill: #b00020;
}
.table .table_content {
    display: flex;
    align-items: center;
}
</style>
